import { useEffect, useState } from "react";
import { entityRows } from "./api";

export interface Account { account: string; descr: string; acct_type: string }
export interface Customer { customer_id: string; customer_name: string; currency_cd: string }
export interface Vendor { vendor_id: string; vendor_name: string; currency_cd: string }

function useEntity<T>(entity: string, map: (r: Record<string, unknown>) => T): T[] {
  const [rows, setRows] = useState<T[]>([]);
  useEffect(() => {
    entityRows(entity).then((rs) => setRows(rs.map(map))).catch(() => setRows([]));
  }, [entity]);
  return rows;
}

export const useAccounts = (): Account[] =>
  useEntity("ps_account", (r) => ({ account: String(r.account), descr: String(r.descr), acct_type: String(r.acct_type) }))
    .sort((a, b) => a.account.localeCompare(b.account));

export const useCustomers = (): Customer[] =>
  useEntity("ps_customer", (r) => ({ customer_id: String(r.customer_id), customer_name: String(r.customer_name), currency_cd: String(r.currency_cd) }));

export const useVendors = (): Vendor[] =>
  useEntity("ps_vendor", (r) => ({ vendor_id: String(r.vendor_id), vendor_name: String(r.vendor_name), currency_cd: String(r.currency_cd) }));
